import axios from "axios";
import { useQuery } from "react-query";
import { toast } from "react-toastify";
import { spdrUrls } from "../../../URL/ApplicationUrls";
import { Spdr } from "../Spdr";
import { objectWithIdNotFoundMessage } from "../../../Messages/errorMessages";
import { namedQueryKeyWithId } from "../../../ReactQuery/namedQueryKeyWithId";

export const useFetchSpdr = (spdrId: number | string | undefined) => {
  return useQuery<Spdr, Error>({
    queryKey: namedQueryKeyWithId("spdrs", spdrId),
    queryFn: () => fetchSpdr(spdrId),
    onError: async () => {
      toast.error(objectWithIdNotFoundMessage(spdrId, "SPDR"));
    },
  });
};

const fetchSpdr = async (id: number | string | undefined) => {
  const { data: spdr } = await axios.get<Spdr>(spdrUrls.spdrWithId(id).apiUrl);

  return spdr;
};
